<template>
<div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
        <app-sidebar></app-sidebar>
        <div id="page-content-wrapper" style="width:100%">
            <i class="material-icons" id="menu-toggle" @click="isSidebar =  !isSidebar">view_headline</i>
            <app-navbar></app-navbar>
            <div class="container-fluid mt-5">
                <div class="col-sm-12">
                    <div class="row dblock" style="padding: 5px;box-shadow: 0 0 15px 0 rgba(0,0,0,.05);">
                        <div class="row">
                            <div class="col-md-12">
                                <vs-breadcrumb align="left" :items="
                  [
                    {
                      title: 'Dashboard',
                      url: 'dashboard'
                    },
                    {
                      title: 'Link 1',
                      url: 'link-1'
                    },
                    {
                      title: 'Link 2',
                      disabled: true
                    },
                    {
                      title: 'Active',
                      active: true
                    }
                  ]"></vs-breadcrumb>
                                <div class="heading mt-3">
                                    <h3 class="text-secondary">Training</h3>
                                </div>
                            </div>
                        </div>
                        <div v-for="(item,index) in formArr" :key="index">
                            <div class="form-group form-row" style="width:100%;">
                                <h6 class="sub-frm-title">Information</h6>

                                <div class="col-md-12 col-lg-12" style="margin-top:30px;">
                                    <div class="floating-label">
                                        <input class="floating-input form-control" type="text" placeholder=" " />
                                        <span class="lbl-label" style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;">
                                            <i class="material-icons" style="font-size: 20px;"></i>
                                        </span>
                                        <label class="lbl-label">Training ID</label>
                                    </div>
                                </div>

                                <div class="col-md-12 col-lg-12" style="margin-top:30px;">
                                    <div class="floating-label">
                                        <input class="floating-input form-control" type="text" placeholder=" " />
                                        <span class="lbl-label" style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;">
                                            <i class="material-icons" style="font-size: 20px;"></i>
                                        </span>
                                        <label class="lbl-label">Event Title</label>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <template v-if="index === 0">
                                    <!-- <span @click="addForms()">
                  <vs-icon icon="add_box" class="add-btn"></vs-icon>
                </span>-->
                                    <b-button class="addnew-btn" @click="addForms()">
                                        <vs-icon icon="add_box" style="margin-right:5px;vertical-align: bottom;"></vs-icon>New
                                    </b-button>
                                </template>
                                <template v-else>
                                    <!-- <span @click="removeForms()">
                  <vs-icon icon="delete_forever" class="delete-btn"></vs-icon>
                </span>-->
                                    <b-button class="delete-btn" variant="danger" @click="removeForms()">
                                        <vs-icon icon="delete" style="margin-right:5px;vertical-align: bottom;"></vs-icon>Delete
                                    </b-button>
                                    <b-button class="addnew-btn" @click="addForms()">
                                        <vs-icon icon="add_box" style="margin-right:5px;vertical-align: bottom;"></vs-icon>New
                                    </b-button>
                                </template>
                            </div>
                        </div>
                        <!-- save button starts-->
                        <a href="#" class="save-btn btn btn-info">Save</a>
                        <!-- <a href="#" class="btn btn-secondary float-right mr-2">Add New</a> -->

                        <!-- save button ends -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import axios from "axios";

export default {
    data: () => ({
        isSidebar: false,
        isForm: true,
        isFormData: false,
        selected: "",
        formArr: 1,
        donerSelected: "",
        donersettings: {
            valueField: "code",
            labelField: "name",
            maxItems: 5,
            plugins: ["remove_button"],
            delimiter: "|"
        },
        thematicareaSelected: "",
        thematicareasettings: {
            valueField: "code",
            labelField: "name",
            maxItems: 5,
            plugins: ["remove_button"],
            delimiter: "|"
        }, // https://github.com/selectize/selectize.js/blob/master/docs/usage.md
        contact_person: "",
        contact_number: "",
        contact_email: "",
        address: "",
        options: {
            format: "DD/MM/YYYY",
            useCurrent: false
        },
        textarea: "",
        counterDanger: false,
        mydate: "",
        startDate: "",
        endDate: "",
        colorx: "#1db952",
        trainingCheck: false,
        repeatedCheck: false,
        select1Normal: "",
        select1: 1,
        select2: 1,
        select3: 1,
        select4: 1,
        select5: 1,
        select6: 1,
        select7: 1,
        select8: 1,
        thematicareaArr: [{
                text: "Select Thematic Area 1",
                value: 1
            },
            {
                text: "Select Thematic Area 2",
                value: 2
            },
            {
                text: "Select Thematic Area 3",
                value: 3
            },
            {
                text: "Select Thematic Area 4",
                value: 4
            },
            {
                text: "Select Thematic Area 5",
                value: 5
            }
        ],
        subprogramtitleArr: [{
                text: "Subprogram 1",
                value: 1
            },
            {
                text: "Subprogram 2",
                value: 2
            },
            {
                text: "Subprogram 3",
                value: 3
            },
            {
                text: "Subprogram 4",
                value: 4
            },
            {
                text: "Subprogram 5",
                value: 5
            }
        ],
        projecttitleArr: [{
                text: "Project Title 1",
                value: 1
            },
            {
                text: "Project Title 2",
                value: 2
            },
            {
                text: "Project Title 3",
                value: 3
            },
            {
                text: "Project Title 4",
                value: 4
            }
        ],
        trainingtitleArr: [{
                text: "Provincial training for preventiion of drugs",
                value: 1
            },
            {
                text: "Global Training for prevention techniques against drug",
                value: 2
            }
        ],
        subprogramArr: [{
                text: "SUB PROGRAM ONE",
                value: 1
            },
            {
                text: "SUB PROGRAM TWO",
                value: 2
            }
        ],
        donernameArr: [{
                text: "UNDP Pakistan",
                value: 1
            },
            {
                text: "UNICEIF",
                value: 2
            },
            {
                text: "UNHCR",
                value: 3
            }
        ],
        typeofDesignationArr: [{
                text: "Program Advisor",
                value: 1
            },
            {
                text: "Program Officer",
                value: 2
            },
            {
                text: "Trainer",
                value: 3
            },
            {
                text: "IT-Devloper",
                value: 4
            },
            {
                text: "IT-DevloperM & E Officer",
                value: 5
            }
        ],
        countryArr: [{
                text: "Pakistan",
                value: 1
            },
            {
                text: "Other",
                value: 2
            }
        ],

        provinceArr: [{
                text: "Khyber Pakhtunkhwa",
                value: 1
            },
            {
                text: "PUNJAB",
                value: 2
            },
            {
                text: "Islamabad",
                value: 3
            },
            {
                text: "Sind",
                value: 4
            },
            {
                text: "Balochistan",
                value: 5
            },
            {
                text: "Azad Kashmir",
                value: 6
            }
        ],
        cityArr: [{
                text: "Mardan",
                value: 1
            },
            {
                text: "Peshawar",
                value: 2
            }
        ],
        departmentArr: [{
                text: "Police Dedpartment KP",
                value: 1
            },
            {
                text: "Police Dedpartment PUNJAB",
                value: 2
            },
            {
                text: "Police Dedpartment ISLAMABAD",
                value: 3
            },
            {
                text: "Sind Police",
                value: 4
            }
        ],
        selecttrainerArr: [{
                text: "Sir Aism Jalal",
                value: 1
            },
            {
                text: "Sir Hayyan",
                value: 2
            },
            {
                text: "Dr Naveed",
                value: 3
            }
        ],
        fields: [{
                key: "city",
                label: "City"
            },
            {
                key: "department",
                label: "Department"
            },
            {
                key: "contact_person",
                label: "Contact Person"
            },
            {
                key: "actions",
                label: ""
            }
        ],
        items: [{
                contact_person: "Dr Saif Ullah",
                department: "Police Dedpartment KP",
                city: "Mardan"
            },
            {
                contact_person: "Dr Ata Ullah",
                department: "Police Dedpartment ISLAMABAD",
                city: "Peshawar"
            }
        ],
        traininginfotitle: [{
                key: "trainingtitle",
                label: "Event Title"
            },
            {
                key: "subprogram",
                label: "Sub Program",
                class: "mycol"
            },
            {
                key: "donername",
                label: "Doner Name"
            },
            {
                key: "typeoftraining",
                label: "Type of Training"
            }
        ],
        traininginfoitems: [{
            trainingtitle: "Provincial training for preventiion of drugs",
            subprogram: "SUB PROGRAM ONE",
            donername: "UNDP Pakistan",
            typeoftraining: "TRAINING TYPE 1"
        }]
    }),
    mounted() {
        axios.defaults.headers['Authorization'] = localStorage.getItem('token')
        // Set the initial number of items
        this.totalRows = this.items.length;
    },
    components: {
        "app-navbar": Navbar,
        "app-sidebar": Sidebar
    },
    methods: {
        addForms() {
            this.formArr++;
        },
        removeForms: function () {
            this.formArr--;
        },
        showForm() {
            this.isForm = false;
            this.isFormData = true;
        }
    }
};
</script>

<style scoped>
#menu-toggle {
    display: none;
}

@media(max-width:768px) {
    #menu-toggle {
        display: block;
    }
}

.dblock {
    display: block !important;
}

.input-color {
    margin-bottom: 10px;
    position: relative;
    display: block;
}

.myNavbar {
    color: rgb(255, 255, 255);
}

.dflex {
    display: flex;
}

.fcenter {
    justify-content: center;
    align-items: center;
}

.pleft-5 {
    margin-left: 5px;
}

.selectExample {
    margin: 10px;
}

.con-select-example {
    display: flex;
    align-items: center;
    justify-content: center;
}

.con-select .vs-select {
    width: 100%;
}

@media (max-width: 550px) {
    .con-select {
        flex-direction: column;
    }

    .con-select .vs-select {
        width: 100%;
    }
}

.form-row {
    padding: 8px;
    color: #1465a3;
    border: 1px dotted #07a7e14f;
    margin-left: 0px !important;
    margin-right: 0px !important;
}

.field {
    width: 100%;
    text-transform: capitalize;
    border-bottom: 2px solid #d0d0d0;
    border-top: none !important;
    border-left: none !important;
    border-right: none !important;
    box-shadow: none !important;
    border-radius: 0 !important;
    transition: all 0.2s ease-in-out 0.2s;
    -webkit-transition: all 0.2s ease-in-out 0.2s;
    -moz-transition: all 0.2s ease-in-out 0.2s;
}

.sub-frm-title {
    padding: 5px;
    background-color: #fff;
    margin-top: -25px;
    text-align: center;
    color: rgba(7, 167, 225, 0.61);
}

/* overide css of vuesax */
.vs-con-input-label {
    width: 100% !important;
}

.vs-con-input-label.is-label-placeholder {
    margin-top: 8px !important;
}

.frm-title {
    text-align: center;
    padding: 10px;
    color: #009ad2;
    /* border-bottom: 2px solid #009ad2; */
}

.addnew-btn {
    font-size: 12px;
    box-shadow: none;
    border-color: #6c757d;
    background-color: #6c757d;
    float: right;
    margin: 10px 0px;
}

.save-btn {
    box-shadow: none;
    font-size: 12px;
    border-color: rgba(7, 167, 225, 0.61);
    background-color: rgba(7, 167, 225, 0.61);
    float: right;
    margin: 10px 5px;
}

.delete-btn {
    font-size: 12px;
    box-shadow: none;
    color: #fff !important;
    /* border-color: rgba(7, 167, 225, 0.61);
  background-color: rgba(7, 167, 225, 0.61); */
    float: right;
    margin: 10px 0px 0px 5px;
}

.add-locations-btn {
    box-shadow: none;
    border-color: rgba(7, 167, 225, 0.61);
    background-color: rgba(7, 167, 225, 0.61);
    margin: 10px 0px;
}

.btn-primary:not(:disabled):not(.disabled):active,
.btn-primary:not(:disabled):not(.disabled).active,
.show>.btn-primary.dropdown-toggle {
    color: #fff;
    border-color: rgba(7, 167, 225, 0.61);
    background-color: rgba(7, 167, 225, 0.61);
}

.new-training {
    padding-right: 10px;
}

.title-text {
    margin-bottom: 0px;
}

.selectize-control.multi .selectize-input>div {
    background: rgba(7, 167, 225, 0.61);
    color: #333333;
}

.con-select {
    font-size: 0.85rem !important;
}

.selectize-input.items.not-full.has-options.has-items {
    font-size: 0.85rem !important;
}

/* Floating label css starts */
/****  floating-Lable style start ****/
.floating-label {
    position: relative;
    margin-bottom: 5px;
}

.floating-input,
.floating-select {
    font-size: 14px;
    padding: 4px 30px 4px 5px;
    display: block;
    width: 100%;
    height: 36px;
    box-shadow: none !important;
    /* background-color: transparent; */
    border: none;
    border: 1px solid #ccc;
}

.floating-input:focus,
.floating-select:focus {
    outline: none;
    border: 2px solid rgba(7, 167, 225, 0.61);
}

label.lbl-label {
    color: #ccc;
    font-size: 14px;
    font-weight: normal;
    position: absolute;
    pointer-events: none;
    left: 5px;
    top: 6px;
    transition: 0.2s ease all;
    -moz-transition: 0.2s ease all;
    -webkit-transition: 0.2s ease all;
}

.floating-input:focus~label.lbl-label,
.floating-input:not(:placeholder-shown)~label.lbl-label {
    background-color: #ffffff;
    /* background-color: #fff; */
    top: -12px;
    left: 10px;
    font-size: 14px;
    color: rgba(7, 167, 225, 0.61);
    padding: 0px 5px;
}

.floating-select:focus~llabel.lbl-label,
.floating-select:not([value=""]):valid~label.lbl-label {
    top: -18px;
    font-size: 14px;
    color: #5264ae;
}

/* active state */
.floating-input:focus~.bar:before,
.floating-input:focus~.bar:after,
.floating-select:focus~.bar:before,
.floating-select:focus~.bar:after {
    width: 50%;
}

*,
*:before,
*:after {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
}

/* highlighter */
/* .highlight {
  position: absolute;
  height: 50%;
  width: 100%;
  top: 15%;
  left: 0;
  pointer-events: none;
  opacity: 0.5;
} */

/* active state */
.floating-input:focus~.highlight,
.floating-select:focus~.highlight {
    -webkit-animation: inputHighlighter 0.3s ease;
    -moz-animation: inputHighlighter 0.3s ease;
    animation: inputHighlighter 0.3s ease;
}

/* animation */
@-webkit-keyframes inputHighlighter {
    from {
        background: #5264ae;
    }

    to {
        width: 0;
        background: transparent;
    }
}

@-moz-keyframes inputHighlighter {
    from {
        background: #5264ae;
    }

    to {
        width: 0;
        background: transparent;
    }
}

@keyframes inputHighlighter {
    from {
        background: #5264ae;
    }

    to {
        width: 0;
        background: transparent;
    }
}

/****  floating-Lable style end ****/

/* Floating label css ends */

.display-table ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
    overflow: hidden;
}

.display-table li {
    float: left;
    padding: 5px 5px;
}

.display-table li a {
    cursor: inherit;
    font-size: 14px;
    display: block;
    color: #747679;
    text-align: center;
    padding: 5px;
    text-decoration: none;
    background-color: #f1f1f1;
}

.tbl-head th {
    font-weight: 400 !important;
    color: rgba(7, 167, 225, 0.61);
}

.display-table {
    /* margin-bottom: 0px !important; */
    color: #8e8e8e;
}

.display-table th,
.display-table td {
    padding: 5px 10px !important;
    /* border: 1px dotted #07a7e14f; */
}
</style>
